import { observer } from 'mobx-react';
import { ParticipantResource } from '../../../../../../ParticipantsStore/Types';
import ModalStore from '../../../../../Modal/Store';
import { GroupParticipantsResource } from '../../../../Group/GroupParticipantsStore/Types';
import AddParticipantStore from '../../../Store';
import ReadyModal from './ReadyModal';
import { ParticipantState } from '../../../Store/Types';

export interface Props {
  modalStore: ModalStore;
  store: AddParticipantStore;
  groupParticipantsResource: GroupParticipantsResource;
  newParticipants: ReadonlyArray<ParticipantResource>;
  state: ParticipantState;
}

function Modal({ modalStore, store, groupParticipantsResource, newParticipants, state }: Props) {
  switch (modalStore.state.kind) {
    case 'closed':
      return <></>;
    case 'open':
      return (
        <ReadyModal
          links={groupParticipantsResource.links}
          store={store}
          modalStore={modalStore}
          newParticipants={newParticipants}
          state={state}
        />
      );
  }
}

export default observer(Modal);
